import { render, staticRenderFns } from "./custom-offer-disclaimer.vue?vue&type=template&id=0f2dac24&scoped=true&"
import script from "./custom-offer-disclaimer.vue?vue&type=script&lang=js&"
export * from "./custom-offer-disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./custom-offer-disclaimer.vue?vue&type=style&index=0&id=0f2dac24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2dac24",
  null
  
)

export default component.exports